// Data Dragon patch the bundled champion catalog was built from. Used only as
// the local-dev image fallback below (prod injects VITE_IMAGES_URL).
const DDRAGON_PATCH = '16.14.1';

const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  // Base URL for champion icons. Falls back to Riot's Data Dragon CDN so images
  // work in local dev before our own images bucket is seeded. Both the CDN and
  // our images bucket serve icons as `<ChampionId>.png`, so the same join works.
  imagesUrl:
    import.meta.env.VITE_IMAGES_URL ||
    `https://ddragon.leagueoflegends.com/cdn/${DDRAGON_PATCH}/img/champion`,
};

/** Build the full icon URL from a champion's bare image filename ("Aatrox.png"). */
export function championImageUrl(image: string | null | undefined): string | null {
  if (!image) return null;
  return `${config.imagesUrl}/${image}`;
}

export default config;
